//----- Component --------------------------------------------------------/
// Developer     : Magali Perea
// Creation Date : 28/06/2023
// Version       : 1
// Description   : Ficha con datos del tanque
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import moment from "moment";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import HandymanIcon from "@mui/icons-material/Handyman";
import PersonSearchSharpIcon from "@mui/icons-material/PersonSearchSharp";
import EventIcon from "@mui/icons-material/Event";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ConstructionIcon from "@mui/icons-material/Construction";
import DomainIcon from "@mui/icons-material/Domain";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import Grid from "@mui/material/Grid";

function FichaTanque(props) {
  const [datosformulario, setDatosformulario] = useState(props.datos); //aca viene el rowdata
  const [color, setColor] = useState("primary");

  return (
    <>
      {datosformulario ? (
        <Box
          backgroundColor="#F4F6F6"
          p={3}
          ml={2}
          mr={2}
          mb={8}
          mt={2}
          border={0.5}
          borderColor={"#ABB2B9"}
          borderRadius={4}
        >
          <Grid container spacing={1.5}>
            <Grid item xs={3}>
              <TextField
                fullWidth
                variant="filled"
                placeholder="No registrado"
                type="text"
                focused
                name="nro_serie"
                label="Numero de Serie"
                color={color}
                value={datosformulario.nro_serie}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <StickyNote2Icon />
                    </InputAdornment>
                  ),
                  sx: {
                    borderTopLeftRadius: "10px", // borde redondeado
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                variant="filled"
                placeholder="No registrado"
                type="text"
                focused
                name="id_sisven"
                label="Numero Sisven"
                color={color}
                value={datosformulario.id_sisven}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <StickyNote2Icon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                variant="filled"
                type="number"
                focused
                color={color}
                placeholder="No registrado"
                name="capacidad"
                id="capacidad"
                label="Capacidad"
                value={datosformulario.capacidad}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">m3</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                variant="filled"
                focused
                fullWidth
                color={color}
                placeholder="No registrado"
                name="estado_fisico"
                id="estado_fisico"
                label="Estado Físico"
                value={datosformulario.descr_estado}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <HandymanIcon />
                    </InputAdornment>
                  ),
                  sx: {
                    borderTopRightRadius: "10px", // borde redondeado
                  },
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                variant="filled"
                focused
                color={color}
                placeholder="No registrado"
                name="duenio"
                id="duenio"
                label="Dueño"
                value={datosformulario.descr_duenio}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountBoxIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                variant="filled"
                focused
                color={color}
                placeholder="No registrado"
                name="nombre_fabricante"
                id="fabricante"
                label="Fabricante"
                value={datosformulario.nombre_fabricante}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <ConstructionIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                placeholder="No registrado"
                variant="filled"
                focused
                color={color}
                id="date"
                label="Fecha de Fabricacion"
                name="fecha_fabricacion"
                value={
                  datosformulario.fecha_fabricacion
                    ? moment(datosformulario.fecha_fabricacion).format(
                        "DD/MM/YYYY"
                      )
                    : ""
                }
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <EventIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                fullWidth
                placeholder="No registrado"
                variant="filled"
                focused
                color={color}
                id="date"
                label="Fecha de Compra"
                name="fecha_compra"
                value={
                  datosformulario.fecha_compra
                    ? moment(datosformulario.fecha_compra).format("DD/MM/YYYY")
                    : ""
                }
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <EventIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                placeholder="No registrado"
                variant="filled"
                focused
                color={color}
                id="date"
                label="Sucursal"
                name="sucursal"
                value={datosformulario.sucursal}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <DomainIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                placeholder="No registrado"
                variant="filled"
                focused
                color={color}
                id="date"
                label="Fecha Ingreso Sucursal"
                name="fecha_ubicacion"
                value={
                  datosformulario.fecha_ubicacion
                    ? moment(datosformulario.fecha_ubicacion).format(
                        "DD/MM/YYYY"
                      )
                    : ""
                }
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <EventIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                placeholder="No registrado"
                variant="filled"
                focused
                color={color}
                id="date"
                label="Estado"
                name="estado"
                value={datosformulario.estado_tanque}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <HomeRepairServiceIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                placeholder="No registrado"
                variant="filled"
                focused
                color={color}
                id="date"
                label="Fecha Estado"
                name="fecha_estado"
                value={
                  datosformulario.fecha_estado
                    ? moment(datosformulario.fecha_estado).format("DD/MM/YYYY")
                    : ""
                }
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <EventIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                variant="filled"
                focused
                placeholder="No registrado"
                color={color}
                label="Vencimiento Prueba Hidrálica"
                name="fecha_estado"
                value={
                  datosformulario.vto_pruebahidraulica
                    ? moment(datosformulario.vto_pruebahidraulica).format(
                        "DD/MM/YYYY"
                      )
                    : ""
                }
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <EventIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder="No registrado"
                variant="filled"
                focused
                color={color}
                id="date"
                label="Observaciones"
                name="observaciones"
                value={datosformulario.observaciones}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonSearchSharpIcon />
                    </InputAdornment>
                  ),
                }}
     
              />
            </Grid>
          </Grid>
        </Box>
      ) : null}
    </>
  );
}

export default FichaTanque;
